import React from 'react';

const DestinationSectionLoader = () => (
    <div class="p-5 mx-sm-5">
        <div className="col-12">
            <div className="row">
                <div className="col-3 loader-background loader-vacation-component d-none d-md-block mt-3"></div>
                <div className="col-3 loader-background loader-vacation-component d-none d-md-block mt-3"></div>
                <div className="col-3 loader-background loader-vacation-component d-none d-md-block mt-3"></div>
                <div className="col-3 loader-background loader-vacation-component d-none d-md-block mt-3"></div>
            </div>
        </div>
    </div>
);

export default DestinationSectionLoader;
